// Preview-only phase override (CMS-054). Lets an editor pick any of the 7
// phases to see how a CMS page would render, without affecting the live site
// (which always resolves the real active phase - see activePhase.ts).

import type { PhaseId } from './types.ts';

export type PhasePreviewMode = 'auto' | 'manual';

export interface PhasePreviewTweaks {
  phaseMode: PhasePreviewMode;
  phaseManual: PhaseId;
  // Index signature so this satisfies useTweaks<T extends Record<string, unknown>>
  // (same pattern as HomePage.tsx's TweakState).
  [key: string]: string;
}

export const PHASE_PREVIEW_DEFAULTS: PhasePreviewTweaks = {
  phaseMode: 'auto',
  phaseManual: 'teaser',
};

/**
 * Resolves the phase CmsPage should render as. On the live site (preview is
 * false) this always returns resolvedPhase unchanged - the manual override
 * only ever applies on the /preview/:guid route.
 */
export function resolvePreviewPhase(
  preview: boolean,
  tweaks: PhasePreviewTweaks,
  resolvedPhase: PhaseId | null,
): PhaseId | null {
  return preview && tweaks.phaseMode === 'manual' ? tweaks.phaseManual : resolvedPhase;
}
